import { Directive, ElementRef, HostListener, Injector } from '@angular/core';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import moment from 'moment';
import Swal from 'sweetalert2';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTextMaskDate]'
})
export class TextMaskDateDirective {
  private control!: NgControl;
  maskedInputController: any;
  mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd/mm/yyyy');

  @HostListener('blur', ['$event']) onblur(event: any) {
    debugger
    let date = event.target.value.split('/')
    if ((event.target.value != null && event.target.value != "") && (date[0].trim() != "" && date[1].trim() != "" && date[2].trim() != "")) {
      if ((!(moment(event.target.value, "DD/MM/YYYY").isValid()) || !(/^\d{2}\/\d{2}\/\d{4}$/.test(event.target.value))) && window.location.pathname != '/trial-balance') {
        Swal.fire('', "Please enter a valid date.", 'warning')
        this.control.control!.setValue(null);
        this.element.nativeElement.focus();
      }
      if (moment(event.target.value, "DD/MM/YYYY").isBefore(moment("01/01/1753", "DD/MM/YYYY")) && window.location.pathname != '/trial-balance') {

        Swal.fire({          
          text: " Date cannot be less than 01/01/1753.",
          icon: 'warning',
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.control.control!.setValue(null);
            setTimeout(() => {
              this.element.nativeElement.focus();
            }, 500)
          }
        })
      }

      if (moment(event.target.value, "DD/MM/YYYY").isAfter(moment("01/01/4000", "DD/MM/YYYY"))) {
        Swal.fire({
          text: " Date should be less than 01/01/2090.",
          icon: 'warning',
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.control.control!.setValue(null);
            setTimeout(() => {
              this.element.nativeElement.focus();
            }, 500)
          }
        })
      }
    }
    else
      this.control.control!.setValue(null);
  }
  //@HostListener('paste', ['$event'])
  //onPaste(event: ClipboardEvent) {
  //  event.preventDefault();
  //  const pastedInput: string = event.clipboardData!
  //    .getData('text/plain')
  //  this.element.nativeElement.selectionStart = 0;
  //  if (moment(pastedInput).isValid())
  //    document.execCommand('insertText', false, pastedInput);

  //}
  constructor(private element: ElementRef, injector: Injector,) {
    try {
      this.control = injector.get(NgControl)
    }
    catch (e) {
    }
    this.maskedInputController = textMask.maskInput({
      inputElement: this.element.nativeElement,
      mask: this.mask,
      showMask: true,
      pipe: this.autoCorrectedDatePipe,
      keepCharPositions: true,
      placeholderChar: '\u2000',
      guide: true,
    });
  }
}
